/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type Me, meApi } from '../api/me.js';

/** The signed-in user's profile (name + email + roles). Cached for the session. */
export function useMe(): UseQueryResult<Me> {
  return useQuery({ queryKey: ['me'], queryFn: () => meApi.get(), staleTime: Infinity });
}
